import { MobiDocument } from './MobiDocument';

export class InformationIndividuDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private information : string;
    private individu_id : number;
    private type : string;

    public constructor(informationIndividu : any){
        super()
        this._id = informationIndividu._id;
        this._rev = informationIndividu._rev;
        this.id = informationIndividu.id;
        this.information = informationIndividu.information;
        this.individu_id = informationIndividu.individu_id;
        this.type = informationIndividu.type;
    }
    
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getInformation(): string {
        return this.information;
    }

    public setInformation(information: string): void {
        this.information = information;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }
}